<div class="snackbar" *ngIf="shown$ | async">
  <ui-snack *ngFor="let snack of bar$ | async" [snack]="snack"></ui-snack>
</div>
